import {Button, Typography, Layout} from 'antd';
import { useAuth0 } from "@auth0/auth0-react";
import {Navigate} from "react-router-dom";

export default function PageLogin() {
    const { isAuthenticated, loginWithRedirect } = useAuth0();
    let page = <Layout style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '-10%',
        backgroundColor: 'transparent'
    }}>
        <Typography><Typography.Title>Please log in to continue</Typography.Title></Typography>
        <Button type={'primary'} size={'large'} onClick={() => loginWithRedirect()}>Login</Button>
    </Layout>;

    if(isAuthenticated) {
        page = <Navigate to="/" replace />
    }
    return (
        <>{page}</>
    );
}